import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import WidgetCard from "./WidgetCard";
import { BB_FILTERS_OPTIONS, COLORS } from "@ts/constants";
import { Col, Radio, Row } from "antd";
import { AvailabilityCharts, PriceImpactBuyboxWinChartType } from "@/ts/common-types";

const PriceImpactBuyboxWinWidget: React.FC<any> = ({
    widgetData,
    currencySymbol,
    chartFilters,
    setChartFilters,
    maxDates
}) => {

    const limitedData = {
        categories: widgetData?.categories?.slice(0, maxDates),
        prices: widgetData?.prices?.slice(0, maxDates),
        bbwinPercentages: widgetData?.bbwinPercentages?.slice(0, maxDates),
        availabilityPercentage: widgetData?.availabilityPercentage?.slice(0, maxDates)
    };

    const [yAxisOppositeData, setYAxisOppositeData] = useState(limitedData.prices);

    useEffect(() => {
        if (chartFilters[AvailabilityCharts.BB_WIN_IMPACT] === "price") {
            setYAxisOppositeData(limitedData.prices);
        }

        if (chartFilters[AvailabilityCharts.BB_WIN_IMPACT] === "availability") {
            setYAxisOppositeData(limitedData.availabilityPercentage);
        }
    }, [chartFilters]);

    const chartOptions = {
        chart: {
            type: "column",
        },
        title: {
            text: "",
            style: {
                fontWeight: "normal",
            },
        },
        colors: COLORS,
        credits: {
            enabled: false,
        },
        exporting: {
            enabled: false,
        },
        xAxis: {
            categories: limitedData?.categories,
            title: {
                text: "Weeks",
                style: {
                    fontWeight: "normal",
                },
            },
        },
        yAxis: [
            {
                title: {
                    text: "Buybox Win %",
                    style: {
                        fontWeight: "normal",
                    },
                },
                labels: {
                    formatter: function (this: any) {
                        return this.value + "%";
                    },
                },
            },
            {
                title: {
                    text: `${chartFilters[AvailabilityCharts.BB_WIN_IMPACT] === "price" ? `Price ${currencySymbol}` : "Availability %"}`,
                    style: {
                        fontWeight: "normal",
                    },
                },
                labels: {
                    formatter: function (this: any) {
                        return `${chartFilters[AvailabilityCharts.BB_WIN_IMPACT] === "price" ? `${currencySymbol} ${this.value}` : `${this.value}`}`;
                    },
                },
                opposite: true,
            },
        ],
        series: [
            {
                name: PriceImpactBuyboxWinChartType.BBWin,
                type: "column",
                data: limitedData.bbwinPercentages,
            },
            {
                name: `${chartFilters[AvailabilityCharts.BB_WIN_IMPACT] === "price" ? "Price" : "Availability"}`,
                type: "line",
                data: yAxisOppositeData,
                yAxis: 1,
                color: "red",
                marker: {
                    enabled: true,
                },
            },
        ],
    };

    return (
        <WidgetCard className="my-4">
            <Row className="fs-5 mb-5 w-100" justify="space-between">
                <Col span={16}>
                    <h5>Price Impact on Buy Box Win %</h5>
                </Col>
                <Col span={8} className="text-end">
                    <Radio.Group
                        size="small"
                        className="ms-4"
                        options={BB_FILTERS_OPTIONS}
                        onChange={(e) => setChartFilters({ type: AvailabilityCharts.BB_WIN_IMPACT, payload: e.target.value })}
                        value={chartFilters[AvailabilityCharts.BB_WIN_IMPACT]}
                        optionType="button"
                        buttonStyle="solid"
                    />
                </Col>
            </Row>
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </WidgetCard>
    );
};

export default PriceImpactBuyboxWinWidget;